import { $radius_border_base } from '../pebbleGlobalToken/border.js';
import { $color_grey_4, $color_grey_8, $color_brand_light_bg_default, $color_brand_border_default, $color_brand_text_defalut, $color_grey_2, $color_grey_6 } from '../pebbleGlobalToken/color.js';
import { $font_size_1, $font_size_2 } from '../pebbleGlobalToken/font.js';

/**
 * 标签-默认背景色
 * @description enDesc: -
 * @description type: Color
 * @description value: $color_grey_4
 */
var $tag_default_bg = $color_grey_4;

/**
 * 标签-默认边框色
 * @description enDesc: -
 * @description type: Color
 * @description value: $color-grey-4
 */
var $tag_default_border_color = $color_grey_4;

/**
 * 标签-默认颜色
 * @description enDesc: -
 * @description type: Color
 * @description value: $color-grey-8
 */
var $tag_default_color = $color_grey_8;

/**
 * 标签-边框圆角--常规
 * @description enDesc: -
 * @description type: Border
 * @description value: $radius-border-base
 */
var $tag_default_border_radius = $radius_border_base;

/**
 * 标签-选中 背景色
 * @description enDesc: -
 * @description type: Color
 * @description value: $color_brand_light_bg_default
 */
var $tag_checked_bg = $color_brand_light_bg_default;

/**
 * 标签-选中 边框色
 * @description enDesc: -
 * @description type: Color
 * @description value: $color_brand_border_default
 */
var $tag_checked_border_color = $color_brand_border_default;

/**
 * 标签-选中 颜色
 * @description enDesc: -
 * @description type: Color
 * @description value: $color_brand_text_defalut
 */
var $tag_checked_color = $color_brand_text_defalut;

/**
 * 标签-禁用 背景色
 * @description enDesc: -
 * @description type: Color
 * @description value: $color-grey-2
 */
var $tag_disabled_bg = $color_grey_2;

/**
 * 标签-禁用 边框色
 * @description enDesc: -
 * @description type: Color
 * @description value: $color-grey-4
 */
var $tag_disabled_border_color = $color_grey_4;

/**
 * 标签-禁用 颜色
 * @description enDesc: -
 * @description type: Color
 * @description value: $color-grey-6
 */
var $tag_disabled_color = $color_grey_6;

/**
 * 标签-较小高度
 * @description enDesc: -
 * @description type: Font
 * @description value: 24
 */
var $tag_size_height_small = 24;

/**
 * 标签-medium 高度
 * @description enDesc: -
 * @description type: Font
 * @description value: 28
 */
var $tag_size_height_medium = 28;

/**
 * 标签-较大高度
 * @description enDesc: -
 * @description type: Font
 * @description value: 32
 */
var $tag_size_height_large = 32;

/**
 * 标签-较小字体大小
 * @description enDesc: -
 * @description type: Font
 * @description value: $font-size-1
 */
var $tag_size_font_size_small = $font_size_1;

/**
 * 标签-medium字体大小
 * @description enDesc: -
 * @description type: Font
 * @description value: $font-size-1
 */
var $tag_size_font_size_medium = $font_size_1;

/**
 * 标签-较大字体大小
 * @description enDesc: -
 * @description type: Font
 * @description value: $font-size-2
 */
var $tag_size_font_size_large = $font_size_2;

/**
 * 标签-较小行高大小
 * @description enDesc: -
 * @description type: Font
 * @description value: 16
 */
var $tag_size_line_height_small = 16;

/**
 * 标签-medium行高大小
 * @description enDesc: -
 * @description type: Font
 * @description value: 20
 */
var $tag_size_line_height_medium = 20;

/**
 * 标签-较大行高大小
 * @description enDesc: -
 * @description type: Font
 * @description value: 22
 */
var $tag_size_line_height_large = 22;

export { $tag_checked_bg, $tag_checked_border_color, $tag_checked_color, $tag_default_bg, $tag_default_border_color, $tag_default_border_radius, $tag_default_color, $tag_disabled_bg, $tag_disabled_border_color, $tag_disabled_color, $tag_size_font_size_large, $tag_size_font_size_medium, $tag_size_font_size_small, $tag_size_height_large, $tag_size_height_medium, $tag_size_height_small, $tag_size_line_height_large, $tag_size_line_height_medium, $tag_size_line_height_small };
